const STATE = "KudaUserInfo";
export const INVITEDSIGNATORYSTATE = "KudaInvitedSignatoryData"

export const setState = (state) => {
    try {
        const stringifiedState = JSON.stringify(state);
        localStorage.setItem(STATE, stringifiedState);
        return stringifiedState;
    } catch (err) {

    }
};
export const getState = () => {
    try {
        const userObject = localStorage.getItem(STATE);
        if (userObject === null) {
            return undefined;
        }
        const parsedObj = JSON.parse(userObject);
        return parsedObj;
    } catch (err) {
        return undefined;
    }
};

// Session storage function for invited signatories
export const setInvitedSignatorySessionData = (key, state) => {
    try {
        const stringifiedState = JSON.stringify(state);
        sessionStorage.setItem(key, stringifiedState);
        return stringifiedState;
    } catch (err) {

    }
};
export const getInvitedSignatorySessionData = (key) => {
    try {
        const signatoryObject = sessionStorage.getItem(key);
        if (signatoryObject === null) {
            return undefined;
        }
        const parsedObj = JSON.parse(signatoryObject);
        return parsedObj;
    } catch (err) {
        return undefined;
    }
};
